import { Component, OnInit, inject, TemplateRef } from "@angular/core";
import { ThemeOptions } from "../../../../../theme-options";
import { Router } from "@angular/router";
import { LogedInUserService } from "../../../../../Services/loged-in-user.service";
import { CrudService } from "../../../../../Services/crud.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-user-box-login",
    templateUrl: "./user-box-login.component.html",
    standalone: false
})
export class UserBoxLoginComponent implements OnInit {
  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  constructor(
    public globals: ThemeOptions,
    private router: Router,
    private logedInUserService: LogedInUserService,
    private crudService: CrudService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {}

  closeModal() {
    this.modalService.dismissAll();
  }

  
  closeResult = "";

  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }
}
